import {User, Rocket, ArrowLeft} from "lucide-react";

const SignupCompleteView = ({
  formData,
  isSignupFormValid,
  isActionLoading,
  handleInputChange,
  handleCompleteProfile,
  handleOnBack,
}) => {
  // Real <form> + type="submit" so the mobile keyboard's Go/Enter key
  // finishes signup exactly like tapping Get started. The back button
  // must stay type="button" or it would submit the form too.
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSignupFormValid && !isActionLoading) handleCompleteProfile();
  };

  return (
    <form className="w-full max-w-md" onSubmit={handleSubmit} noValidate>
      <div>
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-[#191919]">
            Tell us your name
          </h2>
          <p className="mt-1 text-sm text-gray-400">
            This is how you'll show up on your account.
          </p>
        </div>
        <div className="space-y-4">
          <div className="relative">
            <User className="absolute left-4 top-3 text-gray-300" size={20} />
            <input
              id="firstname"
              placeholder="First name"
              value={formData.firstname}
              onChange={handleInputChange}
              className="w-full pl-12 pr-4 py-3 bg-white border border-gray-100 rounded-3xl outline-none focus:ring-2 focus:ring-blue-50"
            />
          </div>
          <div className="relative">
            <User className="absolute left-4 top-3 text-gray-300" size={20} />
            <input
              id="lastname"
              placeholder="Last name"
              value={formData.lastname}
              onChange={handleInputChange}
              className="w-full pl-12 pr-4 py-3 bg-white border border-gray-100 rounded-3xl outline-none focus:ring-2 focus:ring-blue-50"
            />
          </div>
        </div>
      </div>
      <div className="mt-6">
        <button
          type="submit"
          disabled={!isSignupFormValid || isActionLoading}
          className={`w-full py-4 md:py-3 rounded-full text-white text-xl font-bold transition-all ${isSignupFormValid && !isActionLoading ? "bg-black hover:bg-gray-800 shadow-lg" : "bg-gray-300 cursor-not-allowed"}`}
        >
          <Rocket size={22} className="inline mr-2" /> Get started
        </button>
        <button
          type="button"
          className="w-full mt-3 py-4 md:py-3 rounded-full bg-[#f8faff] text-[#1a1a1a] font-bold flex items-center justify-center gap-2 hover:bg-blue-50"
          onClick={handleOnBack}
        >
          <ArrowLeft size={20} /> Use a different phone or email
        </button>
      </div>
    </form>
  );
};

export default SignupCompleteView;
